<template>
  <div>
    <v-row>
      <div>
        <v-field-select v-model='id_agence_eau' label="Mon agence de l'eau" :options="agences" labelField="nom" valueField="id_agence_eau" @select="id_source = null" name="agence_eau">
          <div v-if="agence.url_redevance" class="link external">
            <a :href="agence.url_redevance" target="_blank">Infos sur les tarifs</a>
          </div>
        </v-field-select>
      </div>
      <v-field-select v-if="sources.length > 0" v-model='id_source' label="Source de prélèvement" :options="sources" labelField="type_source" valueField="id_source" @select="zre = null" name="type_source"  :tooltip="true"/>
    </v-row>
    <v-row>
      <v-field-select-bool v-if="hasZre" v-model='zre' label="Classement en ZRE" :options="listeZre" @select="gestion_collective = null" name="zre" :tooltip="true"/>
      <v-field-select-bool v-if="hasGestionCollective" v-model='gestion_collective' label="Gestion collective" :options="gestionCollective" @select="ztm = null" name="gestion_collective" :tooltip="true"/>
      <v-field-select-bool v-if="hasZtm" v-model='ztm' label="Classement en ZTM" :options="listeZtm" @select="ztq = null" name="ztm" :tooltip="true"/>
      <v-field-select-bool v-if="hasZtq" v-model='ztq' label="Classement en ZTO" :options="listeZtq" name="ztq" :tooltip="true"/>
    </v-row>
    <v-row>
      <div>
        <v-field-text v-if="prixEauCalcule" v-model="prixEauCalcule" readonly label="Redevance agence de bassin (cts€/m3)" :tooltip="true" name="redevance"/>
      </div>
      <v-field-text v-model="coutConso" readonly label="Energie de pompage (cts€/m3)" :tooltip="true" name="pompage"/>
    </v-row>
  </div>
</template>

<script>

export default {
  name: 'CalculPrixEau',
  inject: ['$validator'],

  props: {
    value: {
      type: Number
    },
    coutConso: {
      type: String
    }
  },

  data () {
    return {
      id_agence_eau: null,
      id_source: null,
      zre: null,
      gestion_collective: null,
      ztm: null,
      ztq: null
    }
  },

  created () {
    this.$store.dispatch('referentiel/loadPrixEau')
      .then(() => {
        if (this.value) {
          let current = this.$store.state.referentiel.prixEau.find(p => p.id_ref_prix_eau === this.value)
          if (current) {
            this.id_agence_eau = current.id_agence_eau
            this.id_source = current.id_source
            this.zre = current.zre
            this.gestion_collective = current.gestion_collective
            this.ztm = current.ztm
            this.ztq = current.ztq
          }
        }
      })
  },

  computed: {
    agences () {
      return this.$store.state.referentiel.agences
    },
    allSources () {
      return this.$store.state.referentiel.typeSource
    },
    allListePrixEau () {
      return this.$store.state.referentiel.prixEau
    },
    // Agence
    agence () {
      return this.agences.find(a => a.id_agence_eau === this.id_agence_eau) || {}
    },
    // Source
    sources () {
      let idSources = this.allListePrixEau.filter(p => p.id_agence_eau === this.id_agence_eau)
        .map(p => p.id_source)
      return this.allSources.filter(s => idSources.includes(s.id_source))
    },
    // Liste prix eau
    listePrixEau () {
      return this.$store.state.referentiel.prixEau.filter(p =>
        p.id_agence_eau === this.id_agence_eau &&
        p.id_source === this.id_source
      )
    },
    // ZRE
    hasZre () {
      return this.listePrixEau.filter(p => p.zre !== null).length > 0
    },
    listeZre () {
      return [...new Set(this.listePrixEau.map(p => p.zre))]
    },
    listePrixEauByZre () {
      return this.listePrixEau.filter(p => p.zre === this.zre)
    },
    // Gestion Collective
    hasGestionCollective () {
      return this.listePrixEauByZre.filter(p => p.gestion_collective !== null).length > 0
    },
    gestionCollective () {
      return [...new Set(this.listePrixEauByZre.map(p => p.gestion_collective))]
    },
    listePrixEauByZreGc () {
      return this.listePrixEauByZre.filter(p => p.gestion_collective === this.gestion_collective)
    },
    // ZTM
    hasZtm () {
      return this.listePrixEauByZreGc.filter(p => p.ztm !== null).length > 0
    },
    listeZtm () {
      return [...new Set(this.listePrixEauByZreGc.map(p => p.ztm))]
    },
    listePrixEauByZreGcZtm () {
      return this.listePrixEauByZreGc.filter(p => p.ztm === this.ztm)
    },
    // ZTQ
    hasZtq () {
      return this.listePrixEauByZreGcZtm.filter(p => p.ztq !== null).length > 0
    },
    listeZtq () {
      return [...new Set(this.listePrixEauByZreGcZtm.map(p => p.ztq))]
    },
    listePrixEauByZreGcZtmZtq () {
      return this.listePrixEauByZreGcZtm.filter(p => p.ztq === this.ztq)
    },
    // Prix final
    prixEauCalcule () {
      if (this.listePrixEauByZreGcZtmZtq.length === 1) {
        if (this.listePrixEauByZreGcZtmZtq[0].id_ref_prix_eau !== this.value) {
          this.$emit('input', this.listePrixEauByZreGcZtmZtq[0].id_ref_prix_eau)
        }
        return this.listePrixEauByZreGcZtmZtq[0].prix_eau
      }
      return null
    }
  }
}

</script>
